export const QueryKeys = {
    GetCertificates: 'get-all-certificates',
}
